import React from 'react';
import { Badge } from 'reactstrap';
 import IconAdd from 'react-icons/lib/md/add';
import IconEye from 'react-icons/lib/md/remove-red-eye';
import IconMdDate from 'react-icons/lib/md/date-range';
import IconMdAirplanemodeActive from 'react-icons/lib/md/airplanemode-active';
import {appHelpers} from "../../_helpers";
import ToolTipItem from "../utils/tooltip";

const NotInvoicedRecord = ({report, getInvoiceIssuers, toggleInvoiceModal}) => {
    const currencyCode =  String.fromCharCode(appHelpers.getCurrencyUnicode(report.Currency));
    return (
        <blockquote className="invoice-c blockquote">
            <h6><IconMdAirplanemodeActive size="18" color="#2962ff"/> {`${report.AirlineCode} - ${report.ProcessName}`}</h6>
            <footer className="blockquote-footer blockquote-footer-clear">
                <div className="row">
                    <div className="col-sm-3">
                        <p className="m-0 tag">Invoiced (IATA)</p>
                    </div>
                    <div className="col-sm-2">
                        <p className="m-0 tag">Billed (NCAA)</p>
                    </div>
                    <div className="col-sm-2">
                        <p className="m-0 tag">Rebilled</p>
                    </div>
                    <div className="col-sm-2">
                        <p className="m-0 tag">Returned</p>
                    </div>
                    <div className="col-sm-3">
                        <p className="m-0 tag">Outstanding</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3">
                        <h6>
                            <span>{ currencyCode}</span>{appHelpers.numberWithCommas(report.IataAmount)}
                        </h6>
                    </div>
                    <div className="col-sm-2">
                        <h6>
                            {appHelpers.numberWithCommas(report.NcaaAmount)}
                        </h6>
                    </div>
                    <div className="col-sm-2">
                        <h6>
                            {appHelpers.numberWithCommas(report.Rebilled)}
                        </h6>
                    </div>
                    <div className="col-sm-2">
                        <h6>
                            {appHelpers.numberWithCommas(report.Returned)}
                        </h6>
                    </div>
                    <div className="col-sm-3">
                        <h6>
                            {appHelpers.numberWithCommas(report.Difference)}
                        </h6>
                    </div>
                </div>

                <div className="row mt-1">
                    <div className="col-sm-12 blockquote-footer ">
                          <span>
                               <IconMdDate size="14" color="#202021"/> <ToolTipItem key={`${report.Id}DateSupplied`} title={ appHelpers.formatDate(report.DateSupplied)} content='Process Date' id={ `${report.Id}DateSupplied` }/>
                          </span>&nbsp;&nbsp;&nbsp;&nbsp;
                        <span>
                            <ToolTipItem key={`${report.Id}ConvertedAmount`} title={`${appHelpers.numberWithCommas(report.Converted)}`} content='Converted Amount' id={ `${report.Id}ConvertedAmount` }/>
                        </span> |&nbsp;&nbsp;
                        <span>
                            <ToolTipItem key={`${report.Id}ROE`} title={`${appHelpers.numberWithCommas(report.ROE)}`} content='ROE' id={ `${report.Id}ROE` }/>
                        </span>&nbsp;&nbsp;&nbsp;&nbsp;
                        <Badge className='pointer badge-success' key={ `${report.Id}Badge` } onClick={ () => toggleInvoiceModal(report.Id) }> &nbsp;<IconAdd size="14" color="#ffffff"/> Generate Invoice&nbsp;&nbsp; </Badge>
                        &nbsp;&nbsp;
                        <Badge className='pointer badge-info' key={ `${report.Id}IssuerBadge` } onClick={ () => getInvoiceIssuers(report) }> <IconEye size="14" color="#ffffff"/>&nbsp; View Issuer &nbsp;</Badge>
                    </div>
                </div>
            </footer>
        </blockquote>
    );
};

export default NotInvoicedRecord;



// WEBPACK FOOTER //
// ./src/views/invoice/not-invoiced-record.js